export default {
  options: [
    // recomment after code will be write
    // { value: 'accessed_date', name: 'Accessed date' },
    // { value: 'updated', name: 'Changed date' },
    { value: 'number_of_topics', name: 'Number of topics' },
    { value: 'created', name: 'Created date' },
    { value: 'watchlist_name', name: 'Watchlist name' },
  ],
  scending: [
    { value: 'ascending', name: 'Ascending (A-Z)' },
    { value: 'descending', name: 'Descending (Z-A)' },
  ],
};
